<template>
    <div>
        <admin-app-label class="my-4">SEO Tags</admin-app-label>
        <div class="grid grid-cols-2 gap-6">
            <div class="mb-6 mb:mb-0">
                <admin-app-label>H1 Tag</admin-app-label>
                <input-basic
                    placeholder="H1 Tag"
                    :modelValue="proxyValue.h1_tag"
                    @update:modelValue="update('h1_tag', $event)"
                    :error="errors['seo_tags.h1_tag']"
                />
                <input-error :error="errors['seo_tags.h1_tag']"/>
            </div>
            <div class="mb-6 mb:mb-0">
                <admin-app-label>Page Title</admin-app-label>
                <input-basic
                    placeholder="Page Title"
                    :modelValue="proxyValue.page_title"
                    @update:modelValue="update('page_title', $event)"
                    :error="errors['seo_tags.page_title']"
                />
                <input-error :error="errors['seo_tags.page_title']"/>
            </div>
        </div>
        <div class="grid grid-cols-2 gap-6">
            <div class="mb-6 mb:mb-0">
                <admin-app-label>Meta Description</admin-app-label>
                <input-basic
                    placeholder="Meta Description"
                    :modelValue="proxyValue.meta_description"
                    @update:modelValue="update('meta_description', $event)"
                    :error="errors['seo_tags.meta_description']"
                />
                <input-error :error="errors['seo_tags.meta_description']"/>
            </div>
            <div class="mb-6 mb:mb-0">
                <admin-app-label>Canonical Tag</admin-app-label>
                <input-basic
                    placeholder="Canonical Tag"
                    :modelValue="proxyValue.canonical_tag"
                    @update:modelValue="update('canonical_tag', $event)"
                    :error="errors['seo_tags.canonical_tag']"
                />
                <input-error :error="errors['seo_tags.canonical_tag']"/>
            </div>
        </div>
        <div class="grid grid-cols-2 gap-6">
            <div class="mb-6 mb:mb-0">
                <admin-app-label>Sitemap Priority</admin-app-label>
                <input-basic
                    placeholder="Sitemap Priority"
                    type="number"
                    min="0"

                    step="0.1"
                    :modelValue="proxyValue.priority"
                    @update:modelValue="update('priority', $event)"
                    :error="errors['seo_tags.priority']"
                />
                <input-error :error="errors['seo_tags.priority']"/>
            </div>
            <div class="mb-6 mb:mb-0">
                <admin-app-label>Sitemap Update Frequency</admin-app-label>
                <input-select
                    :options="['daily', 'weekly', 'monthly', 'yearly']"
                    placeholder="Sitemap Update Frequency"
                    :modelValue="proxyValue.frequency"
                    @update:modelValue="update('frequency', $event)"
                    :error="errors['seo_tags.frequency']"
                />
                <input-error :error="errors['seo_tags.frequency']"/>
            </div>
        </div>
    </div>
</template>

<script setup>
import {computed} from "vue";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";
import InputError from "@/Components/Forms/Inputs/InputError";

const props = defineProps({
    modelValue: Object,
    errors: Object
});

const defaultSeoTags = {
    h1_tag: null,
    page_title: null,
    meta_description: null,
    canonical_tag: null,
    frequency: null,
    priority: null
};

const proxyValue = computed(() => props.modelValue ?? defaultSeoTags);

const emit = defineEmits(["update:modelValue"]);

function update(key, value) {
    emit("update:modelValue", {...proxyValue.value, [key]: value});
}
</script>

<style scoped>

</style>
